export const EXAM_RECENT_YEAR_COUNT = 3;
export const EXAM_CATALOG_PATH = '/examens/annales';
export const EXAM_BAC_PATH = '/examens/bac';
export const EXAM_SETUP_STEP = Object.freeze({ FORMAT: 'format', CONFIG: 'config', SOURCE: 'source', SUBJECT: 'subject', MODE: 'mode', CHAPTER: 'chapter', REVIEW: 'review' });
export const EXAM_SETUP_COPY = Object.freeze({
  chooseExam: 'Tu prépares quel examen ?', brevet: 'Le brevet', bac: 'Le bac',
  format: 'Un sujet PDF ou interactif ?', pdf: 'Un sujet PDF', pdfHint: 'Le sujet et son corrigé, directement à la source.',
  interactive: 'Un sujet interactif', interactiveHint: 'Passe l’épreuve et retrouve ta copie corrigée.',
  config: 'Comment veux-tu commencer ?', recommended: 'Configuration recommandée',
  recommendedHint: 'Un sujet tiré au sort parmi les trois années disponibles les plus récentes.',
  adjust: 'Ajuster', adjustHint: 'Choisis le sujet, l’épreuve complète, 30 minutes ou un chapitre.',
  source: 'Quel type de sujet ?', subject: 'Quel sujet veux-tu travailler ?', mode: 'Comment veux-tu t’entraîner ?',
  chapter: 'Quel chapitre ?', review: 'Ton épreuve', back: 'Retour',
  start: 'Commencer l’épreuve', random: 'Tirer un sujet au sort', randomHint: 'Parmi les années récentes.',
  step: (current, total) => `Étape ${current} sur ${total}`,
  catalogTitle: 'Les annales de maths', catalogLead: 'Les sujets et les corrigés, directement chez leur éditeur.',
  search: 'Rechercher un sujet', searchHint: 'Métropole, Polynésie, sujet zéro…', year: 'Année',
  class: 'Classe', subjectFilter: 'Matière', maths: 'Mathématiques', allYears: 'Toutes les années',
  allClasses: 'Toutes les classes', sort: 'Trier', newest: 'Année décroissante', oldest: 'Année croissante',
  alphabetic: 'Session A → Z', paper: 'Sujet PDF', correction: 'Corrigé PDF',
  additionalCorrection: (index) => `Autre corrigé ${index}`, empty: 'Aucun sujet ne correspond à ta recherche.',
  otherSource: (host) => `Autre source · ${host}`,
  count: (count) => `${count} sujet${count > 1 ? 's' : ''}`, catalogBack: 'Passer un sujet interactif',
});
